export const isDocumentHidden = () : boolean => {
    return ('visibilityState' in document) && document.visibilityState == 'hidden'
} 